<template>
  <v-card>
    <v-row>
      <v-col cols="12" md="5" order-md="2">
        <div class="box mb-5">
          <v-layout
            d-block
            d-md-flex
            row
            ma-0
            align-center
            justify-space-between
            class="box-header"
          >
            <h3>
              <template v-if="thxContent && thxContent.length > 0">
                <template v-for="(item, index) in thxContent">
                  <template v-if="item.type === 'title' && item.text">
                    <pre v-html="item.text" :key="index"></pre>
                  </template>
                </template>
              </template>
            </h3>
          </v-layout>

          <div class="box-content">
            <template v-if="thxContent && thxContent.length > 0">
              <template v-for="(item, index) in thxContent">
                <p v-if="item.type === 'text' && item.text" :key="index">
                  <pre v-html="item.text"></pre>
                </p>
              </template>
            </template>
          </div>
        </div>
        <div class="box">
          <v-layout
            d-block
            d-md-flex
            row
            ma-0
            align-center
            justify-space-between
            class="box-header"
          >
            <h3>
              <template v-if="nextContent && nextContent.length > 0">
                <template v-for="(item, index) in nextContent">
                  <template v-if="item.type === 'title' && item.text">
                    <pre v-html="item.text" :key="index"></pre>
                  </template>
                </template>
              </template>
            </h3>
          </v-layout>

          <div class="box-content">
            <template v-if="nextContent && nextContent.length > 0">
              <template v-for="(item, index) in nextContent">
                <p v-if="item.type === 'text' && item.text" :key="index">
                  <pre v-html="item.text"></pre>
                </p>
              </template>
            </template>
          </div>
        </div>
      </v-col>

      <v-col cols="12" md="7">
        <div class="box-outlined" ref="#PDF">
          <div class="box-header">
            <h2>{{ $t("certificate-request.title-1") }}</h2>
          </div>
          <div class="box-content">
            <div class="pa-0 p-md-3">
              <v-layout
                d-block
                d-md-flex
                row
                ma-0
                mb-5
                align-center
                justify-space-between
              >
                <v-flex xs12 md8 mb-3>
                  <IDCard
                    v-if="firm"
                    class="instruction"
                    :id="firm.id"
                    :title="firm.title"
                    :address="firm.address"
                    :city="firm ? firm.city : null"
                    :zip="firm ? firm.zip : null"
                    :vat="firm ? firm.vat : null"
                    :nr="firm ? firm.nr : null"
                    :reg="firm ? firm.reg : null"
                    noEdit
                  ></IDCard>
                  <IDCard v-else></IDCard>
                </v-flex>
                <v-flex xs12 md4><h2 class="text-center" ref="#date">{{getDate}}</h2></v-flex>
              </v-layout>

              <h1
                v-if="survey"
                ref="#title"
                class="mb-4"
                v-html="survey.info[`title_${$i18n.locale}`]"></h1>
              <h1 v-else ref="#title" class="mb-4">{{ $t("certificate-request.error-load") }}</h1>

              <v-layout
                d-block
                d-md-flex
                row
                ma-0
                align-start
                justify-space-between
              >
                <v-flex xs12 md4 mb-7>
                  <h2 class="mb-2">
                    {{ survey ?
                      `${Math.round((parseInt(survey.done.question) / parseInt(survey.total.question)) * 100)}% ${$t("certificate-request.score-1")}` :
                      `0% ${$t("certificate-request.score-1")}` }}</h2>
                  <small>{{ $t("final-report.indice-label-1") }}</small>
                </v-flex>

                <v-flex xs12 md4 mb-7>
                  <h2 class="mb-2">
                    {{ survey ?
                       `${$t("certificate-request.score-2")} ${parseInt(survey.done.point)} ${$t("certificate-request.points")}` :
                        `${$t("certificate-request.score-2")} 0 ${$t("certificate-request.points")}`}}</h2>
                  <small>{{ $t("final-report.indice-label-2") }}</small>
                </v-flex>

                <v-flex xs12 md4 mb-7>
                  <h2 class="mb-2">
                    {{ survey ?
                       `${$t("certificate-request.score-3")} ${parseInt(survey.total.requiredpt)} ${$t("certificate-request.points")}` :
                       `${$t("certificate-request.score-3")} 0 ${$t("certificate-request.points")}`}}</h2>
                  <small>{{ $t("final-report.indice-label-3") }}</small>
                </v-flex>
              </v-layout>

              <v-layout
                d-block
                d-md-flex
                row
                ma-0
                align-start
                justify-start
              >
                <v-layout
                  ma-0
                  mb-5
                  column
                  align-center
                  style="flex: initial;"
                >
                  <!-- <v-btn
                    :elevation="0"
                    rounded
                    color="primary"
                    class="mr-5"
                    @click="PDFfn"
                    :loading="loadPDF"
                  >{{ $t("export-box.dialog.btn-2") }}</v-btn> -->
                  <v-btn
                    :elevation="0"
                    rounded
                    outlined
                    color="primary"
                    class="mr-5"
                    :disabled="pdf ? false : true"
                    :href="pdf"
                    :download="unescaped(survey.info[`title_${$i18n.locale}`])"
                    target="_blank"
                  >{{ $t("export-box.dialog.btn-2") }}</v-btn>
                </v-layout>

                <v-layout
                  ma-0
                  column
                  align-center
                  style="flex: initial;"
                >
                  <v-btn
                    :elevation="0"
                    rounded
                    outlined
                    color="primary"
                    class="mr-5"
                    :disabled="pdffull ? false : true"
                    :href="pdffull"
                    :download="unescaped(survey.info[`title_${$i18n.locale}`])"
                    target="_blank"
                  >{{ $t("export-box.dialog.btn-3") }}</v-btn>
                </v-layout>
              </v-layout>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { makePDF } from '@/js/utils/makePDF'
import { getStatic } from '@/js/static/getStatic'
import { randomBaseUrl } from '@/js/utils/randomBaseUrl'
import IDCard from '@/components/firm/IDCard'

export default {
  components: {
    IDCard: IDCard
  },

  data () {
    return {
      survey: this.$route.params.survey,
      firm: this.$route.params.firm,
      answerid: this.$route.params.answerid,
      thxContent: null,
      nextContent: null,

      loadPDF: false,

      // zip: this.$route.params.answerid && this.$store.state.auth.token ? randomBaseUrl(0, 3) + process.env.VUE_APP_DOWNLOAD_ZIP + `?options=json&answerid=${this.$route.params.answerid}&valid=${this.$store.state.auth.token}` : null,
      pdf: this.$route.params.answerid && this.$store.state.auth.token ? randomBaseUrl(0, 3) + process.env.VUE_APP_DOWNLOAD2_ZIP + `?&answerid=${this.$route.params.answerid}&lang=${this.$i18n.locale ? this.$i18n.locale : 'en'}&valid=${this.$store.state.auth.token}&options=pdf` : null,
      pdffull: this.$route.params.answerid && this.$store.state.auth.token ? randomBaseUrl(0, 3) + process.env.VUE_APP_DOWNLOAD2_ZIP + `?&answerid=${this.$route.params.answerid}&lang=${this.$i18n.locale ? this.$i18n.locale : 'en'}&valid=${this.$store.state.auth.token}` : null,
    }
  },

  computed: {
    getDate () {
      const d = new Date()
      const ye = new Intl.DateTimeFormat('fr', { year: 'numeric' }).format(d)
      const mo = new Intl.DateTimeFormat('fr', { month: 'numeric' }).format(d)
      const da = new Intl.DateTimeFormat('fr', { day: '2-digit' }).format(d)
      // const currentDateWithFormat = new Date().toJSON().slice(0,10).replace(/-/g,'.')
      const currentDateWithFormat = `${da}.${mo}.${ye}`
      return currentDateWithFormat
    }
  },

  methods: {
    PDFfn (val) {
      // if (!this.$store.getters['auth/isAuthenticated']) return
      this.loadPDF = true
      makePDF(this.survey, this.answerid, this.$store.state.auth.token, this.firm)
        .then(() => this.loadPDF = false)
        .catch(() => this.loadPDF = false)
    },
    // zip () {
    //   console.log('zip me')
    // }
    unescaped (string) {
      var txt = document.createElement('textarea')
      txt.innerHTML = string
      return txt.value
    }
  },

  created () {
    // if (!this.$store.getters['auth/isAuthenticated']) return

    const paramsthx ={
      lang: this.$i18n.locale ? this.$i18n.locale : 'en',
      page: 'certificaterequest',
      keyword: 'thx'
    } 
    getStatic(paramsthx)
      .then(response => this.thxContent = response.modules)
      // .catch(error => console.log(error))

    const paramsnext = {
      lang: this.$i18n.locale ? this.$i18n.locale : 'en',
      page: 'certificaterequest',
      keyword: 'next'
    }
    getStatic(paramsnext)
      .then(response => this.nextContent = response.modules)
      // .catch(error => console.log(error))
  }
}
</script>
